








































































import Cookies from 'js-cookie';
import { isFunction } from 'lodash-es';
import { defineComponent, ref, PropType, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FileUploadStatus,
  FullNormalFormData,
  ImageMaterial,
  ImageToUpload,
  ImageUploadSideSlipStatue,
  ImageUploadSideSlipStatueTitle,
} from '@tt4b/ttam-enums';
import { apis, useUploadImageToLibraryServiceApi, useUploadImageApi, useStore, StateEnum } from '@tt4b/ttam-hooks';
import { fileNameFormatter, camelCaseFormDataDeep, getImgSrcByEnv, imgSrcPrefix } from '@tt4b/ttam-utils';

import router from './../../../router';
import MaterialRequirement from '@/components/creative/material-upload/material-requirement/index.vue';

import imageUpload from './dialog/index.vue';

const componentName = 'ttam-material-image-upload-slip';
export default defineComponent({
  name: componentName,
  components: { MaterialRequirement, imageUpload },
  props: {
    limit: { type: Number, default: 20 },
    /** 是否需要多选 */
    multiple: { type: Boolean, default: true },
    /** 支持的图片类型，为空则为不限制 */
    imageModeSupport: { type: Array, default: () => [] },
    /** 是否需要版位校验 */
    inventoryCheck: { type: Boolean, default: true },
    /** 确认事件，如果传入确认事件，则不会调用默认 */
    confirmCallback: {
      type: Function as PropType<(param: any) => void>,
      default: undefined,
    },
    /** 是否是上传封面模式 */
    isUploadCover: { type: Boolean, default: false },
    adgroupData: {
      required: true,
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      required: true,
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      required: true,
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
  },

  setup(props, ctx) {
    /** 记录所有的原始File文件信息，用户重新上传时取出 */
    const originFile = [] as Array<ImageToUpload>;

    /** 上传dialog组件节点 */
    const imageFail = new Set();
    const imageSuccess = new Set();

    const imageUploaderNode = ref();
    let imageSuccessFiles: ImageMaterial[] = [];

    /** 上传时需要添加的 Headers */
    const uploadHeaders = ref({ 'X-CSRFToken': Cookies.get('csrftoken') });

    /** 上传时的地址 */
    const { state, getStore } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);
    const uploadImageUrl = ref(`${apis.material.uploadImage}?aadvid=${aadvid.value}`);
    const acceptFileType = ref('image/png,image/jpeg,image/jpg');

    const uploadBtnNode = ref();
    const files = ref<ImageToUpload[]>();

    const recordOriginFile = fileList => {
      const allUid = originFile.map(item => item.uid);
      fileList.forEach(item => {
        if (!allUid.includes(item)) {
          originFile.push(item);
        }
      });
    };

    const handleStartInternal = () => {
      if (files.value?.length === 0) {
        return;
      }
      let all = files.value?.length ? files.value.length * 100 : 0;
      let sum = 0;
      files.value?.forEach(item => {
        sum = sum + (item?.percentage ? item?.percentage : 0);
      });
      const isUploadDone = imageSuccessFiles.length + imageFail.size === files.value?.length;

      // 上传进度emit
      ctx.emit('progress', {
        allFile: files.value,
        // 上传进度
        percentage: all ? (sum / all) * 100 : 100,
        // 上传是否完毕
        isUploadDone,
        // 成功上传的
        materialArr: imageSuccessFiles,
        // 是否有上传失败的
        hasSomeOneUploadFail: imageFail.size >= 1,
      });
      // 上传完成return
      if (isUploadDone) {
        // 如果存在一个上传成功的就自动confirm
        if (imageSuccessFiles.length >= 1) {
          // 自动confirm
          // onConfirm();
          imageUploaderNode.value?.confirm();
        }

        return;
      }
      // 上传完成结束setTimeout

      // 1.5s更新一次进度
      setTimeout(handleStartInternal, 1000);
    };

    const PageStatue = computed(() => {
      if (files.value?.length) {
        if (imageUploaderNode.value.pageStep === 'validate') {
          return ImageUploadSideSlipStatue.VALIDATE;
        }

        return ImageUploadSideSlipStatue.CROP;
      } else {
        return ImageUploadSideSlipStatue.READY_SELECT;
      }
    });

    /** 从本地选择文件完成事件 */
    function onGetRawFiles(fileRaws) {
      ctx.emit('select-files', fileRaws);
    }

    function cancelUpload() {
      imageUploaderNode.value?.cancelUpload();

      files.value = [];
    }

    function onclose() {
      ctx.emit('closeSideSlip');
    }

    const clearFiles = () => {
      files.value = [];
      uploadBtnNode.value?.clearFiles();
      imageUploaderNode.value?.clearFiles();
      imageSuccessFiles = [];
    };
    function onFilesChange(changedFiles) {
      files.value = changedFiles;
      ctx.emit('start-upload', changedFiles);
    }

    const submit = () => {
      uploadBtnNode.value?.submit();
    };

    /** 用于初始化一些变量 */
    function reset() {
      clearFiles();
      imageSuccessFiles = [];
    }

    /** 确认 */
    function onConfirm() {
      if (!imageSuccessFiles.length) {
        // reset();

        return;
      }

      if (isFunction(props.confirmCallback)) {
        props.confirmCallback(imageSuccessFiles);
        // reset();

        return;
      }

      ctx.emit('confirm', imageSuccessFiles);

      // reset();
    }

    /** 上传失败事件 */
    function onUploadError(res, file) {
      const { uid } = file;
      imageFail.add(uid);
    }

    // async function onUploadSuccess(response, file) {
    //   onUploadError(1, file);
    // }

    /** 上传成功事件 */
    async function onUploadSuccess(response, file) {
      const res = camelCaseFormDataDeep(response);
      if (res.code !== 0) {
        file.status = FileUploadStatus.Fail;
        imageFail.add(file.uid);
        imageUploaderNode.value?.changeFileUploaderStatus(file.name, FileUploadStatus.Fail);

        return;
      }
      if (file.cancel) {
        return;
      }
      if (props.isUploadCover) {
        const { name, width, height, size, webUri } = res?.data?.imageInfo ?? {};
        imageSuccessFiles.push({
          name,
          width,
          height,
          size,
          webUri,
          id: '',
          imageUrl: res?.data?.url,
          verify: file.verify,
        });
        imageUploaderNode.value?.changeFileUploaderStatus(file.name, FileUploadStatus.Success);

        return;
      }
      const { uid } = file;
      const { imageInfo } = res.data;
      const originImage = files.value?.find(f => f.uid === uid);
      let originImageUri = '';
      if (originImage) {
        imageUploaderNode.value?.changeFileUploaderStatus(file.name, FileUploadStatus.Uploading);
        const data = await useUploadImageApi(originImage.raw!);
        originImageUri = data?.imageInfo?.webUri ?? '';
      }
      imageInfo.fileNme = fileNameFormatter({
        name: file.name,
        width: imageInfo.width,
        height: imageInfo.height,
      });
      const libraryRes = await useUploadImageToLibraryServiceApi({
        name: file.name,
        webUri: imageInfo.webUri,
        originalWebUri: originImageUri,
        showError: false,
      });
      if (!libraryRes) {
        imageFail.add(uid);
        imageUploaderNode.value?.changeFileUploaderStatus(file.name, FileUploadStatus.Fail);

        return;
      }
      imageSuccess.add(uid);
      const info = {
        id: uid,
        name: file.name,
        width: imageInfo.width,
        height: imageInfo.height,
        size: imageInfo.size,
        webUri: imageInfo.webUri,
        imageUrl: getImgSrcByEnv({ URL: imgSrcPrefix.URL }, imageInfo.webUri),
        verify: file.verify,
      };
      imageSuccessFiles.push(info);
      imageUploaderNode.value?.changeFileUploaderStatus(file.name, FileUploadStatus.Success);
    }

    function onUploadChange(_file: ImageToUpload, curFiles: ImageToUpload[]) {
      recordOriginFile(curFiles);

      files.value = curFiles.map(item => ({
        ...item,
        croppedCanvas: undefined,
        croppedUrl: undefined,
        uploaderStatus: '',
      }));
    }

    const sleepFn = (sleepTime = 1000) => new Promise(resolve => setTimeout(() => resolve(''), sleepTime));

    const reUpload = async (directReupload = false) => {
      const needReuploadFile = [...imageFail]
        .map(uid => originFile.find(item => item.uid === uid))
        .map(item => ({
          ...item,
          name: String(item?.name) + new Date().getTime(),
        }));
      onUploadChange('' as any, needReuploadFile as any);
      imageFail.clear();
      // 如果是直接上传
      if (directReupload) {
        await sleepFn(1000);
        await imageUploaderNode.value?.cropperConfirm();
        imageUploaderNode.value?.upload();

        // setTimeout(() => {}, 1000);
      }
    };

    return {
      name: componentName,
      onConfirm,
      onclose,
      reset,
      ImageUploadSideSlipStatueTitle,
      imageUploaderNode,
      uploadBtnNode,
      ImageUploadSideSlipStatue,
      PageStatue,
      uploadHeaders,
      uploadImageUrl,
      files,
      acceptFileType,
      cancelUpload,
      handleStartInternal,
      onUploadSuccess,
      onUploadError,
      onUploadChange,
      onGetRawFiles,
      clearFiles,
      submit,
      onFilesChange,
      reUpload,
    };
  },
});
